import { Component, OnInit } from '@angular/core';
import { VendorService } from '../vendor.service';

@Component({
  selector: 'app-top-vendors',
  templateUrl: './top-vendors.component.html',
  styleUrls: ['./top-vendors.component.css']
})
export class TopVendorsComponent implements OnInit {
  page=1;
  currentPage = 1;
  vendors : any = [];
  itemsPerPage = 5;
  pageSize: number;
  totalrecord:number;
  vendorFilter: any = { vendorname: '' };
  constructor(	
    private vendorservice : VendorService,
     ) { }

  ngOnInit() {
    this.getallTopVendors();
  }

    
  getallTopVendors() {
     return this.vendorservice.GetAlltTopVendors()
               .subscribe(
                vendors => {
                  this.vendors = vendors
                  this.totalrecord = this.vendors.length;
                 }
                );
 }

 public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}


}
